export const CUSTOMERS_LIMIT = 5;
export const MAX_EVENT_NAME_SIZE = 100;
export const MAX_EVENT_DATA_SIZE = 10 * 1024 * 1024; // 10 MB
export const DISALLOWED_EVENT_DATA_PROPERTIES = ['attachments', 'from_address', 'recipient', 'reply_to'];
